export default "__VITE_ASSET__C0xUTb52__"